// extracted by mini-css-extract-plugin
module.exports = {"container":"lLE8OL","icon":"_3btdEA","text":"lSOBoV mz-success-label"};